import React, {Component} from "react";  import config from 'react-global-configuration';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import * as moment from "moment";
import {connect}  from  "react-redux";
import Picker from 'react-month-picker'
import MonthBox from "views/MonthBox.jsx";
import "../../assets/css/monthpicker/month-picker.css";
import { isApiResponse } from '../../helpers/utils.js';
import DownloadAllReport from '../DownloadReport/DownloadAllReport.jsx';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

class MonthWiseSummary extends Component{
    constructor(props) {
        super(props);
        this.state ={
            month:'012022',
            mvalue: {year: "2022", month: "01"},
        }
        this.handleClickMonthBox = this.handleClickMonthBox.bind(this);
        this.handleAMonthChange = this.handleAMonthChange.bind(this);
        this.handleAMonthDissmis = this.handleAMonthDissmis.bind(this);
    }

    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");

        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
    }
    componentDidUpdate() {

    }
    componentDidMount() {
       this.get_utid_wise_summary(this.state.month);
      // this.get_month_wise_summary_total(this.state.month);
    }

    handleClickMonthBox (e) {
        this.refs.pickAMonth.show()
    }
    handleAMonthChange(value, text) {
        var month = '';
        if(text.toString().length==1){
            month = "" +0+text;
        }
        else {
            month = text;
        }

        var month_year = "" +month+value;
        this.setState({
            month: month_year,
            mvalue: {year: value, month: text}
        });
        this.get_utid_wise_summary(month_year);
        this.get_month_wise_summary_total(month_year);
    }
    handleAMonthDissmis(value) {
        // this.setState({
        //     mvalue: value
        // });
    }



    get_month_wise_summary_total(month) {
    var that = this;
    setTimeout(function(){
        isApiResponse(false);
        var postData = {
            for_month: month,
            entity: "monthwise-summary",
            sub_entity : "monthwise-summary-total",
        };
        if ($.fn.DataTable.isDataTable('#MonthWiseSummary')) {
            $('#MonthWiseSummary').DataTable().clear().destroy();
        }
        var MonthWiseSummary = $('#MonthWiseSummary').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                //"autoWidth": false,
                "responsive": false,
                "scrollX": false,
                "sPaginationType": "numbers",
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/invoice/view-summary",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true);

                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                    },
                    complete: function (data) {
                        isApiResponse(true);
                    },
                },

                columns: [
                    {"data":"billing_company_name" },
                    {"data":"billing_company_gst_number"},
                    {"data": "for_month"},
                    {"data":"total_tax_amount"},
                    {"data":"total_amount"}
                ],
                "columnDefs": [
                    {  render: function (data) {
                            return data;
                        },

                        "targets": [ 3,4],
                        "className": "text-right"
                    },

                ],
            });
    }.bind(that), 200);
    }
    get_utid_wise_summary(month) {
    var that = this;
    setTimeout(function(){
        isApiResponse(false);
        var postData = {
            for_month: month,
            entity: "monthwise-summary",
            sub_entity : "utid-wise",
        };
        if ($.fn.DataTable.isDataTable('#UTIDWiseSummary')) {
            $('#UTIDWiseSummary').DataTable().clear().destroy();
        }
        var UTIDWiseSummary = $('#UTIDWiseSummary').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                //"autoWidth": false,
                "responsive": false,
                "scrollX": false,
                "sPaginationType": "numbers",
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/invoice/view-summary",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true);

                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                    },
                    complete: function (data) {
                        isApiResponse(true);
                    },
                },

                columns: [
                    {"data":"utid" },
                    {"data":"billing_company_name"},
                    {"data": "master_gst"},
                    {"data":"for_month"},
                    {"data":"price"}
                ],
                "columnDefs": [
                    {  render: function (data) {
                            return data;
                        },

                        "targets": [ 4],
                        "className": "text-right"
                    },

                ],
            });
        }.bind(that), 200);
    }
    DownloadCheck(type, e){
        var sub_entity = "monthwise-summary-total";
        var name = "monthwise_summary_total";
        if(type=='utid-wise') {
            sub_entity = "utid-wise";
            name = "utid_wise";
        }
        var filters = {
            for_month: this.state.month,
            entity: "monthwise-summary",
            sub_entity : sub_entity,
            download:1
        };
        this.refs.downloadAllReport.downLoadReport(filters, '/invoice/monthly/summary', name, 30);
    }


    render() {
        const pickerLang = {
            months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            from: 'From', to: 'To',
        };
        const mvalue = this.state.mvalue
        ;
        const makeText = m => {
            if (m && m.year && m.month) return (pickerLang.months[m.month-1] + '. ' + m.year);
            return '?'
        };
        return(

            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Month Wise Summary Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="col-md-3 filter-bottom5 padd-5 date-icon-small">
                                                <Picker
                                                    ref="pickAMonth"
                                                    theme="light"
                                                    years={{
                                                        max: {
                                                            year: new Date().getFullYear(),
                                                            month: new Date().getMonth()
                                                        },
                                                        min: {year: 2019, month: 4}
                                                    }}
                                                    // years={new Date().getFullYear()}
                                                    value={mvalue}
                                                    lang={pickerLang.months}
                                                    onChange={this.handleAMonthChange}
                                                    onDismiss={this.handleAMonthDissmis}
                                                >
                                            <MonthBox value={makeText(mvalue)} onClick={this.handleClickMonthBox} />
                                        </Picker>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>

                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <Tabs>
                                        <TabList>
                                            <Tab onClick={()=>this.get_utid_wise_summary(this.state.month)}>UTID Wise Summary</Tab>
                                            <Tab onClick={()=>this.get_month_wise_summary_total(this.state.month)}>Month Wise Summary Total</Tab>

                                        </TabList>

                                        <TabPanel>

                                            <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                                <div className="">
                                                    <a href="#" className="exportButton" role="button" onClick={this.DownloadCheck.bind(this,'utid-wise')}>
                                                        <i className="fa fa-download" aria-hidden="true"></i>
                                                        Export to CSV
                                                    </a>
                                                </div>
                                                <table id="UTIDWiseSummary" className="table table-striped table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th>UTID</th>
                                                            <th>Billing Company Name</th>
                                                            <th>GST</th>
                                                            <th>Month</th>
                                                            <th>Price</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                    </tbody>
                                                </table>
                                            </div>

                                        </TabPanel>
                                        <TabPanel>
                                            <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                                <div className="">
                                                    <a href="#" className="exportButton" role="button" onClick={this.DownloadCheck.bind(this,'month-wise')}>
                                                        <i className="fa fa-download" aria-hidden="true"></i>
                                                        Export to CSV
                                                    </a>
                                                </div>
                                                <table id="MonthWiseSummary" className="table table-striped table-hover">
                                                    <thead>
                                                    <tr>
                                                        <th>Billing Company Name</th>
                                                        <th>Billing Company GST Number</th>
                                                        <th>Month</th>
                                                        <th>Total Tax Amount</th>
                                                        <th>Total Amount</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>

                                                    </tbody>
                                                </table>
                                            </div>
                                        </TabPanel>

                                        </Tabs>
                                        <div className="clearfix"></div>

                                    </div>
                                    <DownloadAllReport ref="downloadAllReport" />
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         
       );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( MonthWiseSummary);